(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amazon-creator-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('amazon-creator-videos')) return;

    class AmazonCreatorVideos extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();

        this.abortController = new AbortController();
        this.signal = this.abortController.signal;

        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.progress = this.querySelector('[data-carousel-progress]');
        this.dialog = this.querySelector('[data-video-dialog]');
        this.player = this.querySelector('[data-video-player]');

        if (!this.track || !this.dialog || !this.player) return;

        /*
         * Shopify 编辑器重新加载 Section 时，
         * 先清理之前生成的循环副本。
         */
        this.track
          .querySelectorAll('[data-loop-copy]')
          .forEach((card) => {
            if (card.dataset.loopCopy !== '0') {
              card.remove();
            }
          });

        /*
         * 获取原始视频。
         */
        this.originalCards = Array.from(
          this.track.querySelectorAll('[data-video-card]')
        );

        this.originalCount = this.originalCards.length;

        /*
         * 给原始视频固定逻辑编号。
         *
         * 0 = 视频1
         * 1 = 视频2
         * ...
         */
        this.originalCards.forEach((card, index) => {
          card.dataset.loopIndex = String(index);
          card.dataset.loopCopy = '0';
        });

        /*
         * 为了让左右两个方向都拥有足够空间，
         * 前后分别复制两整组。
         *
         * 最终 DOM：
         *
         * -2          -1          0           +1          +2
         *
         * 123456 | 123456 | 123456 | 123456 | 123456
         *
         *                    ↑
         *                  正式组
         */
        this.createCircularCopies();

        this.allCards = Array.from(
          this.track.querySelectorAll('[data-video-card]')
        );

        /*
         * 自动播放。
         */
        this.autoScrollDelay =
          Number.parseInt(
            this.dataset.autoScrollDelay,
            10
          ) || 4000;

        this.autoScrollTimer = null;
        this.scrollSettleTimer = null;
        this.autoRestartTimer = null;
        this.wheelTimer = null;

        /*
         * 状态。
         */
        this.isHovered = this.matches(':hover');
        this.isDialogOpen = false;
        this.isInteracting = false;
        this.isAnimating = false;

        /*
         * 点击太快时把动作排队。
         *
         * 例如连续点三次左：
         *
         * 1 → 6 → 5 → 4
         *
         * 不会因为动画未结束而卡住。
         */
        this.moveQueue = 0;

        /*
         * PC 鼠标拖动。
         */
        this.mouseDragging = false;
        this.dragPointerId = null;
        this.dragStartX = 0;
        this.dragStartScrollLeft = 0;
        this.dragMoved = false;
        this.suppressNextClick = false;

        /*
         * 左箭头。
         */
        this.previousButton?.addEventListener(
          'click',
          () => {
            this.requestMove(-1, true);
          },
          {
            signal: this.signal
          }
        );

        /*
         * 右箭头。
         */
        this.nextButton?.addEventListener(
          'click',
          () => {
            this.requestMove(1, true);
          },
          {
            signal: this.signal
          }
        );

        /*
         * 鼠标放入整个模块：
         * 自动播放暂停。
         *
         * 手动左右移动仍然有效。
         */
        this.addEventListener(
          'mouseenter',
          () => {
            this.isHovered = true;
            this.stopAutoScroll();
          },
          {
            signal: this.signal
          }
        );

        /*
         * 鼠标移出：
         * 继续自动播放。
         */
        this.addEventListener(
          'mouseleave',
          () => {
            this.isHovered = false;

            if (
              !this.isDialogOpen &&
              !this.isInteracting
            ) {
              this.startAutoScroll();
            }
          },
          {
            signal: this.signal
          }
        );

        /*
         * 开始手动拖动。
         */
        this.track.addEventListener(
          'pointerdown',
          (event) => {
            /*
             * 链接、视频播放按钮等交互控件必须保留原生点击。
             * 如果在这里对它们执行 pointer capture，click 会被
             * 重新指向轮播轨道，导致 View Product 和播放按钮失效。
             */
            if (
              event.target.closest(
                'a, button, input, select, textarea, summary, [role="button"]'
              )
            ) {
              return;
            }

            if (
              event.pointerType === 'mouse' &&
              event.button !== 0
            ) {
              return;
            }

            this.isInteracting = true;
            this.stopAutoScroll();

            /*
             * PC 鼠标拖动。
             */
            if (event.pointerType === 'mouse') {
              this.mouseDragging = true;
              this.dragPointerId = event.pointerId;

              this.dragStartX = event.clientX;

              this.dragStartScrollLeft =
                this.track.scrollLeft;

              this.dragMoved = false;

              try {
                this.track.setPointerCapture(
                  event.pointerId
                );
              } catch (_) {}
            }
          },
          {
            passive: true,
            signal: this.signal
          }
        );

        /*
         * PC 鼠标左右拖。
         */
        this.track.addEventListener(
          'pointermove',
          (event) => {
            if (
              !this.mouseDragging ||
              event.pointerId !== this.dragPointerId
            ) {
              return;
            }

            const deltaX =
              event.clientX - this.dragStartX;

            if (Math.abs(deltaX) > 4) {
              this.dragMoved = true;

              this.track.classList.add(
                'is-dragging'
              );

              event.preventDefault();
            }

            this.track.scrollLeft =
              this.dragStartScrollLeft -
              deltaX;
          },
          {
            passive: false,
            signal: this.signal
          }
        );

        /*
         * 手指 / 鼠标结束拖动。
         */
        const finishPointer = (event) => {
          if (
            event.pointerType === 'mouse' &&
            this.mouseDragging
          ) {
            try {
              this.track.releasePointerCapture(
                this.dragPointerId
              );
            } catch (_) {}

            if (this.dragMoved) {
              this.suppressNextClick = true;
            }

            this.mouseDragging = false;
            this.dragPointerId = null;

            this.track.classList.remove(
              'is-dragging'
            );
          }

          if (!this.isInteracting) return;

          this.isInteracting = false;

          /*
           * 等浏览器惯性滑动 / snap 停止后，
           * 再进行环形无感归位。
           */
          this.scheduleScrollSettled(180);

          this.scheduleAutoRestart();
        };

        this.track.addEventListener(
          'pointerup',
          finishPointer,
          {
            passive: true,
            signal: this.signal
          }
        );

        this.track.addEventListener(
          'pointercancel',
          finishPointer,
          {
            passive: true,
            signal: this.signal
          }
        );

        /*
         * PC 拖动后不要误触视频和 View Product。
         */
        this.track.addEventListener(
          'click',
          (event) => {
            if (!this.suppressNextClick) return;

            event.preventDefault();
            event.stopPropagation();

            this.suppressNextClick = false;
          },
          {
            capture: true,
            signal: this.signal
          }
        );

        /*
         * 滚动时更新手机圆点。
         */
        this.track.addEventListener(
          'scroll',
          () => {
            this.updateProgress();

            if (
              !this.isInteracting &&
              !this.isAnimating
            ) {
              this.scheduleScrollSettled(180);
            }
          },
          {
            passive: true,
            signal: this.signal
          }
        );

        /*
         * 触控板 / 鼠标滚轮。
         */
        this.track.addEventListener(
          'wheel',
          () => {
            this.stopAutoScroll();

            this.isInteracting = true;

            if (this.wheelTimer) {
              clearTimeout(this.wheelTimer);
            }

            this.wheelTimer =
              window.setTimeout(
                () => {
                  this.isInteracting = false;

                  this.scheduleScrollSettled(100);

                  this.scheduleAutoRestart();
                },
                180
              );
          },
          {
            passive: true,
            signal: this.signal
          }
        );

        /*
         * 视频关闭按钮。
         */
        this.querySelector('[data-dialog-close]')
          ?.addEventListener(
            'click',
            () => {
              this.closeDialog();
            },
            {
              signal: this.signal
            }
          );

        /*
         * 点击弹窗黑色区域关闭。
         */
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) {
              this.closeDialog();
            }
          },
          {
            signal: this.signal
          }
        );

        /*
         * Dialog 原生关闭事件。
         */
        this.dialog.addEventListener(
          'close',
          () => {
            this.isDialogOpen = false;

            this.releaseVideo();

            if (!this.isHovered) {
              this.startAutoScroll();
            }
          },
          {
            signal: this.signal
          }
        );

        /*
         * 原始视频 + 所有副本视频
         * 全部绑定打开事件。
         */
        this.querySelectorAll('[data-video-trigger]')
          .forEach((trigger) => {
            trigger.addEventListener(
              'click',
              () => {
                this.openVideo(trigger);
              },
              {
                signal: this.signal
              }
            );
          });

        /*
         * 浏览器宽度变化。
         *
         * 保留当前逻辑视频，
         * 然后重新定位。
         */
        window.addEventListener(
          'resize',
          () => {
            const nearest =
              this.getNearestCard();

            if (!nearest) return;

            const index =
              Number(
                nearest.dataset.loopIndex
              );

            requestAnimationFrame(() => {
              const original =
                this.originalCards[index];

              if (original) {
                this.instantScrollToCard(
                  original
                );
              }

              this.updateState();
            });
          },
          {
            passive: true,
            signal: this.signal
          }
        );

        this.buildProgress();

        /*
         * 初始位置。
         *
         * PC：
         * 第一张从左开始。
         *
         * 手机：
         * 第一张严格居中。
         *
         * 因为它左边真的存在：
         * 4 5 6
         *
         * 所以不是假留白。
         */
        requestAnimationFrame(() => {
          if (this.originalCards[0]) {
            this.instantScrollToCard(
              this.originalCards[0]
            );
          }

          this.updateState();

          if (!this.isHovered) {
            this.startAutoScroll();
          }
        });
      }

      disconnectedCallback() {
        this.stopAutoScroll();

        [
          this.scrollSettleTimer,
          this.autoRestartTimer,
          this.wheelTimer
        ].forEach((timer) => {
          if (timer) {
            clearTimeout(timer);
          }
        });

        this.abortController?.abort();

        this.releaseVideo();
      }


      /* ======================================
         创建环形轨道
         ====================================== */

      createCircularCopies() {
        if (this.originalCount <= 1) return;

        const before =
          document.createDocumentFragment();

        const after =
          document.createDocumentFragment();

        /*
         * 左边两套。
         *
         * copy -2
         * copy -1
         */
        [-2, -1].forEach((copyNumber) => {
          this.originalCards.forEach(
            (card, index) => {
              const clone =
                card.cloneNode(true);

              clone.dataset.loopIndex =
                String(index);

              clone.dataset.loopCopy =
                String(copyNumber);

              clone.removeAttribute(
                'data-shopify-editor-block'
              );

              before.appendChild(clone);
            }
          );
        });

        /*
         * 右边两套。
         *
         * copy +1
         * copy +2
         */
        [1, 2].forEach((copyNumber) => {
          this.originalCards.forEach(
            (card, index) => {
              const clone =
                card.cloneNode(true);

              clone.dataset.loopIndex =
                String(index);

              clone.dataset.loopCopy =
                String(copyNumber);

              clone.removeAttribute(
                'data-shopify-editor-block'
              );

              after.appendChild(clone);
            }
          );
        });

        this.track.prepend(before);
        this.track.append(after);
      }


      /* ======================================
         卡片定位
         ====================================== */

      isMobile() {
        return window.matchMedia(
          '(max-width: 749px)'
        ).matches;
      }

      /*
       * 获得某张卡片应该对应的 scrollLeft。
       *
       * PC：
       * 左对齐。
       *
       * 手机：
       * 卡片中心 = 屏幕中心。
       */
      getCardTargetLeft(card) {
        if (!card) return 0;

        const trackRect =
          this.track.getBoundingClientRect();

        const cardRect =
          card.getBoundingClientRect();

        /*
         * 卡片在完整滚动内容里的真实位置。
         */
        const contentLeft =
          this.track.scrollLeft +
          (
            cardRect.left -
            trackRect.left
          );

        /*
         * 手机严格居中。
         */
        if (this.isMobile()) {
          return (
            contentLeft -
            (
              this.track.clientWidth -
              cardRect.width
            ) /
            2
          );
        }

        /*
         * PC 左对齐。
         */
        return contentLeft;
      }

      scrollToCard(
        card,
        behavior = 'smooth'
      ) {
        if (!card) return;

        this.track.scrollTo({
          left:
            this.getCardTargetLeft(card),

          behavior
        });
      }

      /*
       * 环形归位绝对不能有动画。
       *
       * 临时关闭：
       * - smooth
       * - snap
       *
       * 用户完全看不到位置变化。
       */
      instantScrollToLeft(left) {
        const oldBehavior =
          this.track.style.scrollBehavior;

        const oldSnap =
          this.track.style.scrollSnapType;

        this.track.style.scrollBehavior =
          'auto';

        this.track.style.scrollSnapType =
          'none';

        this.track.scrollLeft = left;

        /*
         * 强制提交布局。
         */
        this.track.getBoundingClientRect();

        if (oldBehavior) {
          this.track.style.scrollBehavior =
            oldBehavior;
        } else {
          this.track.style.removeProperty(
            'scroll-behavior'
          );
        }

        if (oldSnap) {
          this.track.style.scrollSnapType =
            oldSnap;
        } else {
          this.track.style.removeProperty(
            'scroll-snap-type'
          );
        }
      }

      instantScrollToCard(card) {
        if (!card) return;

        this.instantScrollToLeft(
          this.getCardTargetLeft(card)
        );
      }

      /*
       * 找到当前最接近“活动位置”的卡片。
       *
       * PC：
       * 看左边缘。
       *
       * 手机：
       * 看屏幕中心。
       */
      getNearestCard() {
        if (!this.allCards.length) {
          return null;
        }

        const trackRect =
          this.track.getBoundingClientRect();

        const anchor =
          this.isMobile()
            ? (
                trackRect.left +
                this.track.clientWidth / 2
              )
            : trackRect.left;

        let nearest = null;
        let nearestDistance = Infinity;

        this.allCards.forEach((card) => {
          const rect =
            card.getBoundingClientRect();

          const cardAnchor =
            this.isMobile()
              ? (
                  rect.left +
                  rect.width / 2
                )
              : rect.left;

          const distance =
            Math.abs(
              cardAnchor -
              anchor
            );

          if (
            distance <
            nearestDistance
          ) {
            nearestDistance = distance;
            nearest = card;
          }
        });

        return nearest;
      }


      /* ======================================
         环形核心
         ====================================== */

      /*
       * 如果当前停在副本，
       * 瞬间切换到完全相同的正式卡片。
       *
       * 不改变用户看到的画面。
       */
      normalizeCircularPosition() {
        if (
          this.isInteracting ||
          this.isAnimating
        ) {
          return;
        }

        const nearest =
          this.getNearestCard();

        if (!nearest) return;

        const copy =
          Number(
            nearest.dataset.loopCopy
          );

        /*
         * 已经在正式组。
         */
        if (copy === 0) return;

        const index =
          Number(
            nearest.dataset.loopIndex
          );

        const original =
          this.originalCards[index];

        if (!original) return;

        /*
         * 记录当前相对于副本目标位置
         * 还有多少细微偏差。
         *
         * 这样即使没有完全 snap，
         * 归位以后画面也完全一致。
         */
        const cloneTarget =
          this.getCardTargetLeft(
            nearest
          );

        const delta =
          this.track.scrollLeft -
          cloneTarget;

        const originalTarget =
          this.getCardTargetLeft(
            original
          );

        this.instantScrollToLeft(
          originalTarget +
          delta
        );
      }

      /*
       * 滚动停止后再归位。
       */
      scheduleScrollSettled(
        delay = 160
      ) {
        if (this.scrollSettleTimer) {
          clearTimeout(
            this.scrollSettleTimer
          );
        }

        this.scrollSettleTimer =
          window.setTimeout(
            () => {
              this.scrollSettleTimer = null;

              if (
                this.isInteracting ||
                this.isAnimating
              ) {
                return;
              }

              this.normalizeCircularPosition();

              this.updateState();
            },
            delay
          );
      }


      /* ======================================
         左右每次移动一张
         ====================================== */

      requestMove(
        direction,
        manual = false
      ) {
        if (
          this.originalCount <= 1
        ) {
          return;
        }

        if (manual) {
          this.stopAutoScroll();

          this.scheduleAutoRestart();
        }

        /*
         * 连续点击不会丢。
         *
         * 左左左：
         * -3
         *
         * 右右：
         * +2
         */
        this.moveQueue += direction;

        /*
         * 避免疯狂点击积累太多。
         */
        this.moveQueue =
          Math.max(
            -12,
            Math.min(
              12,
              this.moveQueue
            )
          );

        this.processMoveQueue();
      }

      processMoveQueue() {
        if (
          this.isAnimating ||
          this.moveQueue === 0
        ) {
          return;
        }

        /*
         * 每次只执行一步。
         */
        const direction =
          this.moveQueue > 0
            ? 1
            : -1;

        this.moveQueue -=
          direction;

        /*
         * 开始下一步前确保当前在正式组。
         */
        this.normalizeCircularPosition();

        const current =
          this.getNearestCard();

        if (!current) return;

        const currentPosition =
          this.allCards.indexOf(
            current
          );

        if (
          currentPosition === -1
        ) {
          return;
        }

        const target =
          this.allCards[
            currentPosition +
            direction
          ];

        /*
         * 理论上前后有两组副本，
         * 正常使用不会到这里。
         */
        if (!target) {
          this.normalizeCircularPosition();

          this.isAnimating = false;

          this.processMoveQueue();

          return;
        }

        this.isAnimating = true;

        this.scrollToCard(
          target,
          'smooth'
        );

        /*
         * 等 smooth 动画完成。
         */
        window.setTimeout(
          () => {
            this.isAnimating = false;

            /*
             * 如果刚刚到了副本，
             * 现在无感回正式组。
             */
            this.normalizeCircularPosition();

            this.updateState();

            /*
             * 如果用户连续点了很多次，
             * 继续执行下一步。
             */
            this.processMoveQueue();
          },
          520
        );
      }


      /* ======================================
         自动轮播
         ====================================== */

      autoScroll() {
        if (
          this.isHovered ||
          this.isDialogOpen ||
          this.isInteracting ||
          this.originalCount <= 1
        ) {
          return;
        }

        /*
         * 自动向右一张，
         * 视觉上视频向左移动。
         */
        this.requestMove(
          1,
          false
        );
      }

      startAutoScroll() {
        this.stopAutoScroll();

        if (
          this.isHovered ||
          this.isDialogOpen ||
          this.isInteracting ||
          this.originalCount <= 1
        ) {
          return;
        }

        if (
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
        ) {
          return;
        }

        this.autoScrollTimer =
          window.setInterval(
            () => {
              this.autoScroll();
            },
            this.autoScrollDelay
          );
      }

      stopAutoScroll() {
        if (!this.autoScrollTimer) return;

        window.clearInterval(
          this.autoScrollTimer
        );

        this.autoScrollTimer = null;
      }

      scheduleAutoRestart() {
        if (this.autoRestartTimer) {
          clearTimeout(
            this.autoRestartTimer
          );
        }

        this.autoRestartTimer =
          window.setTimeout(
            () => {
              this.autoRestartTimer = null;

              if (
                !this.isHovered &&
                !this.isDialogOpen &&
                !this.isInteracting
              ) {
                this.startAutoScroll();
              }
            },
            1200
          );
      }


      /* ======================================
         手机端圆点
         ====================================== */

      buildProgress() {
        if (!this.progress) return;

        this.progress.replaceChildren();

        this.originalCards.forEach(() => {
          const dot =
            document.createElement(
              'span'
            );

          dot.className =
            'amazon-creator-videos__progress-dot';

          this.progress.append(dot);
        });
      }

      updateProgress() {
        if (
          !this.progress ||
          !this.originalCount
        ) {
          return;
        }

        const nearest =
          this.getNearestCard();

        if (!nearest) return;

        const activeIndex =
          Number(
            nearest.dataset.loopIndex
          );

        this.progress
          .querySelectorAll(
            '.amazon-creator-videos__progress-dot'
          )
          .forEach((dot, index) => {
            dot.classList.toggle(
              'is-active',
              index === activeIndex
            );
          });
      }

      updateState() {
        this.classList.toggle(
          'is-static',
          this.originalCount <= 1
        );

        if (this.previousButton) {
          this.previousButton.disabled =
            this.originalCount <= 1;
        }

        if (this.nextButton) {
          this.nextButton.disabled =
            this.originalCount <= 1;
        }

        this.updateProgress();
      }


      /* ======================================
         视频播放
         ====================================== */

      openVideo(trigger) {
        const card =
          trigger.closest(
            '[data-video-card]'
          );

        const template =
          card?.querySelector(
            '[data-video-sources]'
          );

        if (!template) return;

        this.isDialogOpen = true;

        this.stopAutoScroll();
        this.releaseVideo();

        const sources =
          template.content.cloneNode(
            true
          );

        sources
          .querySelectorAll(
            'source[data-src]'
          )
          .forEach((source) => {
            source.src =
              source.dataset.src;

            source.removeAttribute(
              'data-src'
            );
          });

        this.player.append(sources);

        const poster =
          trigger.dataset.videoPoster;

        if (poster) {
          this.player.poster =
            poster;
        }

        if (
          typeof this.dialog.showModal ===
          'function'
        ) {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute(
            'open',
            ''
          );
        }

        this.player.load();

        const playPromise =
          this.player.play();

        if (playPromise?.catch) {
          playPromise.catch(
            () => {}
          );
        }
      }

      closeDialog() {
        if (
          typeof this.dialog.close ===
            'function' &&
          this.dialog.open
        ) {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute(
            'open'
          );

          this.isDialogOpen = false;

          this.releaseVideo();

          if (!this.isHovered) {
            this.startAutoScroll();
          }
        }
      }

      releaseVideo() {
        if (!this.player) return;

        this.player.pause();

        this.player.removeAttribute(
          'poster'
        );

        this.player.replaceChildren();

        this.player.load();
      }
    }

    customElements.define(
      'amazon-creator-videos',
      AmazonCreatorVideos
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
